import { z } from 'zod';
import type { ContributorCategoryToken } from '@sleed/bizcommerce-api';

/**
 * Contributor category (Κατηγορία Συντελεστή) edit form. Mirrors the legacy admin grid
 * (Core/client/admin/src/pages/Contributors/ContributorCategories/index.js): nm required ≤100,
 * cd required ≤50, chex color, ass_to_prd / iv booleans, si required. `nm` is the default-language
 * name saved top-level via the Accept-Language=el pin (GetAllMasterEntityML, parity with Seasons).
 * Server-owned fields not on the form (is_cust, is_default, btrl) survive via spread-on-update.
 */
export const contributorCategorySchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	cd: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong'),
	chex: z.string().nullable(),
	ass_to_prd: z.boolean(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type ContributorCategoryFormValues = z.infer<typeof contributorCategorySchema>;

export const EMPTY_CONTRIBUTOR_CATEGORY: ContributorCategoryFormValues = {
	nm: '',
	cd: '',
	chex: null,
	ass_to_prd: false,
	iv: true,
	si: 0
};

export function tokenToForm(token: ContributorCategoryToken): ContributorCategoryFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		cd: token.cd ?? '',
		chex: token.chex ?? null,
		ass_to_prd: token.ass_to_prd ?? false,
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: ContributorCategoryFormValues, original?: ContributorCategoryToken | null): ContributorCategoryToken {
	return {
		...(original ?? {}),
		id: form.id,
		nm: form.nm.trim(),
		cd: form.cd.trim(),
		chex: form.chex?.trim() || null,
		ass_to_prd: form.ass_to_prd,
		iv: form.iv,
		si: form.si
	};
}
